<template>
    <div class="h-screen w-full flex flex-col items-center justify-center">
        <div class="md:border w-full max-w-md flex flex-col items-center px-8 py-12 rounded-3xl gap-6">
            <span class="text-2xl text-center font-semibold tracking-wide text-primary">Create New Password</span>
            <span class="text-sm tracking-wide leading-relaxed text-center text-secondary">Your new password
                must be different from previously used passwords.</span>
            <div class="w-full flex flex-col justify-start items-start">
                <span class="text-sm text-secondary tracking-wide">Password <span class="text-red-500">*</span></span>
                <a-input-password v-model:value="form.password" size="large" bordered class="w-full mt-2" />
                <span v-if="errors.password" class="text-red-500 text-xs tracking-wide mt-2">{{ errors.password }}</span>
            </div>
            <div class="w-full flex-col justify-start items-start">
                <span class="text-sm text-secondary tracking-wide">Confirm Password <span
                        class="text-red-500">*</span></span>
                <a-input-password v-model:value="form.password_confirmation" size="large" bordered class="w-full mt-2" />
                <span v-if="errors.password_confirmation" class="text-red-500 text-xs tracking-wide mt-2">{{
                    errors.password_confirmation }}</span>
            </div>
            <a-button :loading="isLoading" @click="onSubmit" class="w-full" type="primary" size="large">Reset
                Password</a-button>
        </div>
    </div>
</template>

<script setup>
import { message } from 'ant-design-vue';
import { ref, watch, onMounted } from "vue";
import AuthApi from "../../../api/auth";
import { useRouter, useRoute } from "vue-router";

const token = ref('')

const form = ref({
    password: '',
    password_confirmation: ''
});

const errors = ref({
    password: '',
    password_confirmation: '',
});

watch(form.value, (newValue) => {
    if (newValue.password) errors.value.password = '';
    if (newValue.password_confirmation) errors.value.password_confirmation = '';
});

const validateForm = () => {
    errors.value = { password: '', password_confirmation: '' };
    let isValid = true;

    if (!form.value.password) {
        errors.value.password = 'Password is required.';
        isValid = false;
    }
    if (form.value.password !== form.value.password_confirmation) {
        errors.value.password_confirmation = 'Passwords do not match.';
        isValid = false;
    }

    return isValid;
};

const handleBackendErrors = (backendErrors) => {
    Object.keys(backendErrors).forEach(field => {
        if (errors.value[field] !== undefined) {
            errors.value[field] = backendErrors[field][0]; // Display the first error for each field
        }
    });
};

const router = useRouter();
const route = useRoute();
const isLoading = ref(false);
const authApi = new AuthApi();

onMounted(() => {
    const tokenParam = route.query.token;
    if (!tokenParam) {
        message.error("Token Not Found!")
        setTimeout(() => {
            router.push('/SignIn')
        }, 1500);
    }
    if (tokenParam) {
        token.value = tokenParam;
    }
});

const onSubmit = async () => {
    if (validateForm()) {
        isLoading.value = true;
        try {
            const response = await authApi.resetPassword(token.value, form.value);
            message.success("Password Reset Successfully")

            setTimeout(() => {
                window.location.href = "/SignIn";
            }, 1000);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.errors) {
                handleBackendErrors(error.response.data.errors);
            } else {
                message.error(error?.response?.data?.message ?? 'An error occurred. Please try again later.');
            }
        } finally {
            isLoading.value = false;
        }
    }
};
</script>
